/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  return async function onSubmit({ args }) {
    switch (args?.type) {
      case 'cancel':
        if (typeof props.onCancel === 'function') return props.onCancel()
        break
      case 'close':
        if (typeof props.onClose === 'function') return props.onClose()
        break
      case 'ignoreMatches':
        if (typeof props.onIgnoreMatches === 'function')
          return props.onIgnoreMatches()
        break
      case 'useSelectedLead':
        if (typeof props.onUseSelectedLead === 'function')
          return props.onUseSelectedLead({ ...args })
        break
      case 'useSelectedPatient':
        if (typeof props.onUseSelectedPatient === 'function')
          return props.onUseSelectedPatient({ ...args })
        break
      case 'useSelectedPerson': {
        if (typeof props.onUseSelectedPerson === 'function')
          return props.onUseSelectedPerson({ ...args })
        break
      }
      default:
        return
    }
  }
}
